import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import AnswerPresenter from '@app/components/Player/AnswerPresenter'
import BackLink from '@app/components/ui/buttons/BackLink'
import Api from '@app/api'
import { Student } from '@app/models/users'
import _ from 'lodash'

const Answer = ({ route, student: { participation: { olympiad } } }) => {
  const { history, match: { params: { tour, id } } } = route

  let tasks = tour === 'main' ? olympiad.mainCards : olympiad.trialCards
  let task = _.find(tasks, _.matchesProperty('id', id))

  if (!task) { return null }

  return (
    <div className="student-answer-page page--fullscreen-overlay">
      <div className="student-answer-page__header">
        <div className="h-flex-layout h-flex-layout--ai-center">
          <BackLink to={`/students/tasks/${tour}`} className="h-flex-layout__left m-0" />
          <span className="h-flex-layout__center f--bold text-center">
            { task.name }
          </span>
        </div>
      </div>
      <div className="page page__inner pt-0">
        <h2 className="text-center f--bold m-2">
          { I18n.t('cards.your_answer') }
        </h2>
        <AnswerPresenter
          className="text-center mb-2"
          url={Api.students.answer({ tour, id }).routes.resourcesURL}
        />
        <div className="text-center">
          <Link
            to={`/students/tours/${tour}/tasks/${id}`}
            className="student-answer-page__btn btn btn--border btn--md mr-1">
            { I18n.t('cards.change_answer') }
          </Link>
          <Link
            to={`/students/tasks/${tour}`}
            className="student-answer-page__btn btn btn--blue btn--md ml-1">
            { I18n.t('cards.to_tasks_list') }
          </Link>
        </div>
      </div>
    </div>
  )
}

Answer.propTypes = {
  route: PropTypes.object.isRequired,
  student: PropTypes.instanceOf(Student).isRequired
}

export default Answer
